const   language={
            chinese:1,
            english:2,
            korean:3,
        }
export default {
    language
}


// WEBPACK FOOTER //
// ./src/api/global_variable.js